import BookingDetails from '../components/BookingDetails/BookingDetails';
import SkuModalList from '../components/SkuModalList/SkuModalList';
import { OrderProvider } from '../context/orderContext';
import AllClients from '../pages/allClients/allClients';
import AllModels from '../pages/allModels';
import AllOrders from '../pages/allOrders/allOrders2';
import Dashboard from '../pages/dashboard';
import NewClient from '../pages/newClientOnboard/newClient';
import NewModel from '../pages/newModel/newModel';
import NewOrder from '../pages/newOrder/newOrder';
import AllStudio from '../pages/studios/allStudio';
import Swatches from '../pages/allSwatches';
import SupportingArticle from '../pages/supportingArticle';
import AllSupportingArticles from '../pages/allSupportingArticles';
import LiveShoot from '../components/LiveShoots';
import LiveShootOld from '../components/LiveShoots/Old';
import LivePII from '../components/LivePII';
import LiveOutbound from '../components/LiveOutbound';
import LiveBoxes from '../pages/liveBoxes';
import Guideline from '../components/Guidelines';
import EanDetails from '../components/EansDetails';
import Planning from '../components/Planning';
import ReshootRequest from '../pages/reshootRequest/reshootRequest';
import Unauthorised from '../commonComponents/unauthorised';
import Users from '../pages/users/users';
import CsvTool from '../pages/csvTool/CsvTool';
import ShootPreparation from '../pages/shootPrepaparation';
import Outbounds from '../pages/outbounds';
import DraftPII from '../pages/DraftPII';
import PrintLabelPage from '../pages/PrintLabel';
import StyleColorLibraryPage from '../pages/styleColorLibrary';
import AllCSACarts from '../pages/allCSACarts';
import Tracker from '../pages/tracker';
import ExpectedShipments from '../pages/expectedShipments';
import ReceivedShipments from '../pages/receivedShipments';
import MinibatchPerformance from '../pages/minibatchPerformance';
import Manpower from '../pages/manpower';
import RawQcPerformance from '../pages/rawQcPerformance';
import AssignmentPerformance from '../pages/assignmentPerformance';
import ReadyToPack from '../pages/readyToPack';
import PendingAudit from '../pages/pendingAudit';
import AuditedOutbound from '../pages/auditedOutbound';
import AuditApprovals from '../pages/auditApprovals';
import StudioOpsBoard from '../pages/studioOpsBoard';
import Rejections from '../pages/rejections';
import Reports from '../pages/reports';
import NewsBulletin from '../components/NewsBulletin';
import OrderCsvDataPage from '../pages/orderCsvData';
import SkuIssues from '../pages/skuIssues';
import RateCards from '../pages/rateCards';
import Revenue from '../pages/revenue';

const token = localStorage.getItem('token');

export const routesList = [
    {
        path: `/news/:id`,
        title: "What's New",
        exact: true,
        skipAcl: true,
        component: NewsBulletin,
    },
    {
        path: `/news`,
        title: "What's New",
        exact: true,
        skipAcl: true,
        component: NewsBulletin,
    },
    {
        path: `/dashboard`,
        title: 'Dashboard',
        exact: true,
        protected: true,
        component: AllOrders,
    },
    {
        path: `/rejections`,
        title: 'Rejections',
        aclName: 'Dashboard',
        exact: true,
        protected: true,
        component: Rejections,
    },
    {
        path: `/`,
        title: 'Dashboard',
        exact: true,
        protected: true,
        component: token && AllOrders,
    },
    {
        path: `/onboardNewClient`,
        title: 'Client',
        exact: true,
        component: NewClient,
    },
    {
        path: `/allClients`,
        title: 'Client',
        exact: true,
        component: AllClients,
    },
    {
        path: `/tasksList`,
        title: 'Tasks',
        exact: true,
        // protected: true,
        component: Dashboard,
        // provider:
    },
    {
        path: `/newOrder`,
        title: 'Dashboard',
        exact: true,
        // protected: true,
        component: NewOrder,
        provider: OrderProvider,
    },
    {
        path: `/allStudio`,
        title: 'Studio',
        exact: true,
        // protected: true,
        component: AllStudio,
        // provider:
    },
    {
        path: `/allSkuList`,
        title: 'Skus',
        exact: true,
        // protected: true,
        component: SkuModalList,
        // provider:
    },

    {
        path: `/bookingDetails`,
        title: 'Dashboard',
        exact: true,
        // protected: true,
        component: BookingDetails,
        provider: OrderProvider,
    },
    {
        path: `/supportingArticle`,
        title: 'Supporting Articles',
        exact: true,
        component: SupportingArticle,
        // protected: true,
    },
    {
        path: `/onboardNewClient`,
        title: 'Client',
        exact: true,
        // protected: true,
        component: NewClient,
        // provider:
    },
    {
        path: `/allClients`,
        title: 'Client',
        exact: true,
        // protected: true,
        component: AllClients,
        // provider:
    },
    {
        path: `/allOrders`,
        title: 'Dashboard',
        exact: true,
        // protected: true,
        component: AllOrders,
        // provider:
    },
    {
        path: `/newOrder`,
        title: 'Dashboard',
        exact: true,
        // protected: true,
        component: NewOrder,
        provider: OrderProvider,
    },
    {
        path: `/allStudio`,
        title: 'Studio',
        exact: true,
        // protected: true,
        component: AllStudio,
        // provider:
    },

    {
        path: `/bookingDetails`,
        title: 'Dashboard',
        exact: true,
        // protected: true,
        component: BookingDetails,
        // provider:
    },
    {
        path: `/addModel`,
        title: 'Models',
        exact: true,
        protected: true,
        component: NewModel,
        // provider: OrderProvider,
    },
    {
        path: `/allModels`,
        title: 'Models',
        exact: true,
        // protected: true,
        component: AllModels,
        // provider:
    },
    {
        path: `/allSupportingArticles`,
        title: 'Supporting Articles',
        exact: true,
        // protected: true,
        component: AllSupportingArticles,
        // provider:
    },
    {
        path: `/swatches`,
        title: 'Swatches',
        exact: true,
        // protected: true,
        component: Swatches,
        // provider:
    },
    {
        path: '/LiveShoots',
        title: 'Live Shoot',
        exact: true,
        component: LiveShoot,
    },
    {
        path: '/LiveShootsOld',
        title: 'Live Shoot Old',
        exact: true,
        component: LiveShootOld,
        aclName: 'Live Shoot',
    },
    {
        path: '/LivePii',
        title: 'Live PII',
        exact: true,
        component: LivePII,
    },
    {
        path: '/LiveOutbound',
        title: 'Live Outbound',
        exact: true,
        component: LiveOutbound,
    },
    {
        path: '/LiveBoxes',
        title: 'Live Boxes',
        exact: true,
        component: LiveBoxes,
        aclNames: ['Live Outbound', 'Live PII', 'Pending Audit'],
    },
    {
        path: '/guidelines',
        title: 'Guidelines',
        exact: true,
        component: Guideline,
    },
    {
        path: '/eans',
        title: 'Skus',
        exact: true,
        component: EanDetails,
    },
    {
        path: '/planning',
        title: 'Planning',
        exact: true,
        component: Planning,
    },
    {
        path: '/reports',
        title: 'Reports',
        aclName: 'Dashboard',
        exact: true,
        component: Reports,
    },
    {
        path: '/requests',
        title: 'Requests',
        exact: true,
        component: ReshootRequest,
    },
    {
        path: '/unauthorised',
        title: '',
        exact: true,
        component: Unauthorised,
    },
    {
        path: '/users',
        title: 'Users',
        exact: true,
        component: Users,
    },
    {
        path: `/csvtool`,
        title: 'CSV Generator',
        exact: true,
        // protected: true,
        component: CsvTool,
        // provider:
    },
    {
        path: '/order-csv-data',
        title: 'Order CSV',
        aclName: 'Dashboard',
        exact: true,
        component: OrderCsvDataPage,
    },
    {
        path: '/sku-issues',
        title: 'SKU Issues',
        aclName: 'Dashboard',
        exact: true,
        component: SkuIssues,
    },
    {
        path: `/shootpreparation`,
        title: 'Shoot Preparation',
        exact: true,
        // protected: true,
        component: ShootPreparation,
        // provider:
    },
    {
        path: `/outbound`,
        title: 'Outbound',
        exact: true,
        // protected: true,
        component: Outbounds,
        // provider:
    },
    {
        path: `/draftpii`,
        title: 'Draft PII',
        exact: true,
        // protected: true,
        component: DraftPII,
        // provider:
    },
    {
        path: '/printlabelpage',
        title: 'PrintLabelPage',
        exact: true,
        component: PrintLabelPage,
    },
    {
        path: '/styleColorLibrary',
        title: 'Style & Color Library',
        exact: true,
        component: StyleColorLibraryPage,
    },
    {
        path: '/csa-cart-list',
        title: 'CSACartList',
        exact: true,
        component: AllCSACarts,
    },
    {
        path: '/tracker',
        title: 'Tracker',
        exact: true,
        component: Tracker,
    },
    { path: '/expected-shipments', title: 'Expected Shipments', exact: true, component: ExpectedShipments },
    { path: '/received-shipments', title: 'Received Shipments', exact: true, component: ReceivedShipments },
    { path: '/manpower', title: 'Manpower', aclName: 'Minibatching Performance', exact: true, component: Manpower },
    { path: '/minibatch-performance', title: 'Minibatching Performance', exact: true, component: MinibatchPerformance },
    { path: '/rawqc-performance', title: 'Raw QC Performance', exact: true, component: RawQcPerformance },
    {
        path: '/assignment-performance',
        title: 'Assignment Performance',
        aclName: 'Raw QC Performance',
        exact: true,
        component: AssignmentPerformance,
    },
    { path: '/ready-to-pack', title: 'Ready To Pack', exact: true, component: ReadyToPack },
    { path: '/pending-audit', title: 'Pending Audit', exact: true, component: PendingAudit },
    { path: '/audit-approvals', title: 'Audit Approvals', exact: true, component: AuditApprovals },
    { path: '/audited-outbound', title: 'Audited Outbound', exact: true, component: AuditedOutbound },
    {
        path: '/studio-operations',
        title: 'Studio Operations',
        aclName: 'Studio Operations',
        exact: true,
        component: StudioOpsBoard,
    },
    {
        path: '/revenue',
        title: 'Revenue',
        aclName: 'Revenue',
        exact: true,
        component: Revenue,
    },
    {
        path: '/rate-cards',
        title: 'Rate Cards',
        aclName: 'Revenue',
        exact: true,
        component: RateCards,
    },
];
